var React = require('react');

function VideoPlayLg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M44 0C19.988 0 0.5 19.488 0.5 43.5C0.5 67.512 19.988 87 44 87C68.012 87 87.5 67.512 87.5 43.5C87.5 19.488 68.012 0 44 0ZM30.4062 64.3438L67.5625 43.5L30.4062 22.6562V64.3438ZM2.3125 43.5C2.3125 66.4802 21.0198 85.1875 44 85.1875C66.9802 85.1875 85.6875 66.4802 85.6875 43.5C85.6875 20.5198 66.9802 1.8125 44 1.8125C21.0198 1.8125 2.3125 20.5198 2.3125 43.5Z","fill":"currentColor"}));
}

VideoPlayLg.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 88 87","fill":"none"};

module.exports = VideoPlayLg;

VideoPlayLg.default = VideoPlayLg;
